import { GroupBase, SingleValueProps, components } from 'react-select';

import CountryFlag from '@creditflowresearch/uilib/CountryFlag';

import styles from '../../select.module.scss';

const SingleValueWithCountryFlag = <
  SOption extends { countryCode?: string },
  IsMulti extends boolean,
  Group extends GroupBase<SOption>,
>({
  children,
  ...props
}: SingleValueProps<SOption, IsMulti, Group>) => (
  <components.SingleValue { ...props }>
    <CountryFlag
      className={ styles.countryFlagSingleValue }
      countryCode={ props.data?.countryCode?.toLowerCase() }
    />
    { children }
  </components.SingleValue>
);

export default SingleValueWithCountryFlag;
